import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const batchApi = createApi({
  reducerPath: "batchApi",
  baseQuery: appBaseQuery,
  tagTypes: ["Batch"],
  endpoints: (builder) => ({
    getBatches: builder.query({
      query: (params = {}) => buildPagedListUrl("batch/", params),
      providesTags: ["Batch"],
    }),
    getDispatchHistory: builder.query({
      query: (params = {}) => buildPagedListUrl("batch/dispatch-history", params),
      providesTags: ["Batch"],
    }),
    addBatch: builder.mutation({
      query: (newBatch) => ({
        url: "batch/",
        method: "POST",
        body: newBatch,
      }),
      invalidatesTags: ["Batch"],
    }),
    updateBatch: builder.mutation({
      query: ({ uid, ...updatedBatch }) => ({
        url: `batch/${uid}`,
        method: "PUT",
        body: updatedBatch,
      }),
      invalidatesTags: ["Batch"],
    }),
    dispatchBatch: builder.mutation({
      query: (payload) => ({
        url: "batch/dispatch",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Batch"],
    }),
    downloadDispatchSlip: builder.mutation({
      query: (uid) => ({
        url: `batch/${uid}/dispatch-slip`,
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
    }),
    deleteBatch: builder.mutation({
      query: (uid) => ({
        url: `batch/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Batch"],
    }),
  }),
});

export const {
  useGetBatchesQuery,
  useGetDispatchHistoryQuery,
  useAddBatchMutation,
  useUpdateBatchMutation,
  useDispatchBatchMutation,
  useDownloadDispatchSlipMutation,
  useDeleteBatchMutation,
} = batchApi;
